module.exports = __webpack_public_path__ + "img/Spinning_1200x800.2631c0ed.png";